module.exports = "/static/assets/740b0ad766f4e23a67c948af0c4eff22.png";